import { React, useState, useEffect } from "react";

const PopUpHighcardResults = ({ resultsData, catMid, marketType }) => {
    const resultData = resultsData;

    useEffect(() => {
        console.log("Market Type:", marketType);
        console.log("Results Data:", resultsData);
    }, [resultsData, marketType]);

    const dataObj = resultsData;

    const formatMarketStartTime = (dateString) => {
        if (!dateString) return "";
        const date = new Date(dateString);
        if (isNaN(date.getTime())) return "";
        return date.toLocaleString("en-US", {
            month: "numeric",
            day: "numeric",
            year: "numeric",
            hour: "numeric",
            minute: "2-digit",
            second: "2-digit",
            hour12: true
        });
    };

    let highCardCards = [];
    let highCardPlayers = [];
    let highCardWinner = "";

    if (marketType == 20) {

        highCardCards = resultData.cards_desc
            ? resultData.cards_desc.split(",")
            : [];

        highCardPlayers = [
            resultData.cat_rnr1,
            resultData.cat_rnr2,
            resultData.cat_rnr3,
            resultData.cat_rnr4,
            resultData.cat_rnr5,
            resultData.cat_rnr6,
        ].filter(Boolean);

        highCardWinner = resultData.resultTxt || "";
    }



    return (
        <div>
            <div id="ResultsData">
                <div class="left-content site_family">

                    <div id="high-card" style={{ display: marketType == 20 ? "" : "none" }}>
                        <div className="left-content">
                            <div className="card">
                                <div className="card-header">
                                    Market Start Time = {formatMarketStartTime(dataObj.evt_od)}
                                </div>
                                <div className="card-body">
                                    {highCardPlayers.map((player, index) => (
                                        <div className="player-item" key={index}>
                                            <b>
                                                <span
                                                    className="name"
                                                    style={{ color: "#000" }}
                                                >
                                                    {player}
                                                </span>
                                            </b>

                                            <div className="player-card">
                                                <div className="BFBCardHandViewDealerab">
                                                    <div
                                                        className="BFBCardFanViewab"
                                                        style={{
                                                            justifyContent: "flex-start",
                                                            padding: "2px"
                                                        }}
                                                    >
                                                        {highCardCards[index] && (
                                                            <div className="RSMImageView2ab">
                                                                <img
                                                                    src={`/assets/images/cards/${highCardCards[index]}.svg`}
                                                                    style={{
                                                                        width: "100%",
                                                                        maxWidth: "45px",
                                                                        height: "auto"
                                                                    }}
                                                                />

                                                            </div>
                                                        )}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    ))}
                                    <div style={{ marginTop: "10px" }}>
                                        {highCardPlayers.map((player, index) => {
                                            const winner = player === highCardWinner;
                                            return (
                                                <div
                                                    key={index}
                                                    style={{
                                                        textAlign: "center",
                                                        marginBottom: "18px"
                                                    }}
                                                >
                                                    <div
                                                        style={{
                                                            fontSize: "22px",
                                                            fontWeight: "700"
                                                        }}
                                                    >
                                                        {player}
                                                    </div>
                                                    <div
                                                        style={{
                                                            fontSize: "15px",
                                                            fontWeight: "600",
                                                            marginTop: "4px",
                                                            color: "#000",
                                                            textTransform: "uppercase"
                                                        }}
                                                    >
                                                        {winner ? "WINNER" : "LOSER"}
                                                    </div>
                                                </div>
                                            );
                                        })}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    );
};

export default PopUpHighcardResults;

